"use strict";

var _taggedTemplateLiteral = require("/vercel/path0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(20px);\n  }\n  to {\n    transform: translateY(0);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

exports.bouncedAnimation = styled_components_1.keyframes(_templateObject());